/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { FetchProxyResponse } from './fetch-proxy-response';
import { fetchGetBody } from './fetch-get-body';

/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class FetchWorker {
    constructor() {}

    async sendRequest(input, init, options): Promise<FetchProxyResponse> {
        const responseType = options.responseType;
        // handle FormData

        if (init?.body?.isFormData === true) {
            const formData = new FormData();
            for (const key in init.body) {
                if(key === "isFormData") {
                    continue;
                }
                formData.append(key, init.body[key]);
            }
            init.body = formData;
        }


        return await this.doFetch(input, init, responseType);
    }

    async doFetch(input, init, responseType) {
        const response = await fetch(input, init);
        const body = await fetchGetBody(response, responseType);

        const headers: { [key: string]: any } = {};
        response.headers.forEach((value, key) => (headers[key] = value));
        const responseValues: FetchProxyResponse = {
            ok: response.ok,
            body: body,
            headers: headers,
            status: response.status,
            statusText: response.statusText,
            url: response.url,
        };

        return responseValues;
    }
}
